module.exports = __webpack_public_path__ + "static/media/image1.fea70277.png";